import { Component, OnInit, Inject } from '@angular/core';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AccountService } from 'src/app/services/account.service';
import { Subscription } from 'rxjs';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { CustomValidatorService } from 'src/app/services/custom-validator.service';
import { UserService } from 'src/app/services/user.service';
import { Location } from '@angular/common';
@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.css']
})
export class CreateUserComponent implements OnInit {
  data: any;
  public userForm: UntypedFormGroup;
  sectors: any = [];
  branches: any = [];
  subDomains: any = [];
  subDomain: any = '';
  corporates: any;
  corporate = 0;
  domain: any = 0;
  btnsave: string;
  branch_importedDate = false;
  branchService_importedDate = false;
  branchdepart_importedDate = false;
  bspCorporate = 0;
  branchCorporate = 0;
  bdCorporate = 0;
  branch: any;
  type: any;
  user: any;
  btndisabled = false;
  title: string;
  api_success: string;
  api_error: any;
  configData: any = {};
  userTypes: any = [];
  userDataArray: any = [];
  details;
  users;
  userid: any;
  constructor(private commonService: CommonfilterService, private userService: UserService,
    private formBuilder: UntypedFormBuilder, private customValidator: CustomValidatorService, private location: Location,
    private fileuploadService: FileUploadService, private router: Router, private activatedRoute: ActivatedRoute, private _location: Location) {
    this.createSalesChannelForm();
    this.commonService.getConfigData()
      .subscribe(res => {
        // this.configData = res;
        // this.userTypes = this.configData.userType;
        this.userService.getUserTypes()
        .subscribe(data => {
          this.corporates = data;
          console.log(this.corporates);
          this.userForm.get('userType').setValue(this.corporates[0]);
        });
        // this.salesChannelForm.setValue({ 'scType': 'EMPLOYEE_REF' });
      });
  }
  formErrors = {
    'firstName': '',
    'lastName': '',
    'email': '',
    'password': '',
    'userType': '',
    'mobileNo': '',
    'userStatus': '',
  };
  ValidationMessages = {
    'firstName': {
      'required': 'First Name is Required',
      'whitespace': 'First Name is invalid'

    },
    'lastName': {
      'required': 'Last Name is Required',
      'whitespace': 'Last Name  is invalid'
    },
    'email': {
      'email': 'Email is invalid'
    },
    'password': {
      'required': 'Password is Required'
    },
    'userType': {
      'required': 'User Type is Required'
    },
    'mobileNo' : {
      'minlength': 'Mobile Number should have a minimum length of 10 characters',
      'maxlength': 'Mobile Number should only have a maximum length of 10 characters',
    },
    'userStatus': {
      'required': 'User Status is required'

    },
  };
  createSalesChannelForm() {
    this.userForm = this.formBuilder.group({
      firstName: ['', [Validators.required, this.customValidator.noWhiteSpace]],
      lastName: ['', [Validators.required, this.customValidator.noWhiteSpace]],
      email: [''],
      password: [''],
      userType: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(10)]],
      mobileNo: ['', [Validators.required, Validators.email]],
      userStatus: ['ACTIVE', [Validators.maxLength(10), Validators.minLength(10)]],
    });
  }
  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      console.log(params);
      this.user = params.type;
      console.log(this.user);
      this.data = JSON.parse(params.special);
      console.log(this.data);
    });
    setTimeout(() => {
      if (this.user === 'add') {
        this.btnsave = 'SAVE';
        this.title = 'CREATE';
      } else {
        this.updateSalesChannelForm(this.data);
        this.btnsave = 'UPDATE';
        this.title = 'UPDATE';
      }
    }, 1000);
  }
  updateSalesChannelForm(userDetails) {
    console.log(userDetails);
    this.userid = userDetails.user.id;
    console.log(this.userid)
    this.userForm.patchValue({
      firstName: userDetails.firstName,
      lastName:  userDetails.lastName,
      email: userDetails.email,
      password: userDetails.password,
      userType: userDetails.userType,
      mobileNo: userDetails.user.primaryMobileNo ,
      userStatus: userDetails.status ,
    });

  }
  goBacktoList() {
    this.router.navigate(['../list'], { relativeTo: this.activatedRoute });
  }
  goBacktoListt() {
    this.location.back();
 }
  onUserSubmit() {
    const form_data = this.userForm.value;
    if (this.user === 'add') {
      this.createUserData(form_data);
    } else {
      this.updateUserData(form_data , this.userid);
    }

    // this.createUserData(form_data);
  }
  createUserData(data) {
    this.userService.createUser(data)
      .subscribe(res => {
        console.log(data);
        this.api_success = 'User Created Successfully';
        setTimeout(() => {
        }, 1000);
        this._location.back();
        // this.router.navigate(['../list'], { relativeTo: this.activatedRoute });
      },
        (error) => {
          this.api_error = error.error;
        }
      );
     
  }
  updateUserData(data , id) {
    this.userService.updateUser(data , id)
      .subscribe(res => {
        console.log(data);
        this.api_success = 'User Updated Successfully';
        setTimeout(() => {
        }, 1000);
        this._location.back();
        // this.router.navigate(['../list'], { relativeTo: this.activatedRoute });
      },
        (error) => {
          this.api_error = error.error;
        }
      );
  }
  logValidationErrors(group: UntypedFormGroup = this.userForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if (abstractControl && !abstractControl.valid &&
        (abstractControl.touched || abstractControl.dirty)) {
        const messages = this.ValidationMessages[key];
        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }

      if (abstractControl instanceof UntypedFormGroup) {
        this.logValidationErrors(abstractControl);
      }
    });


  }
}


